module.exports = __webpack_public_path__ + "img/userimg.155b8910.jpg";